export const TRUSTPILOT_URL = 'https://uk.trustpilot.com/review/cityrelay.com';

// Props for any element that should open the Trustpilot review page in a new tab
export const trustpilotLinkProps = {
  href: TRUSTPILOT_URL,
  target: '_blank',
  rel: 'noopener noreferrer',
  'aria-label': 'CityRelay reviews on Trustpilot (opens in a new tab)',
};
